import { FC } from 'react'
import { Button } from '../../../../../components'
import { FormularioAtendimentoList } from '../../../avaliacoes/avaliacoes-pendentes-list/core/_models'

type Props = {
  formularios: FormularioAtendimentoList[]
  onSelect: (formulario: FormularioAtendimentoList) => void
}

/**
 * Formulários que ainda podem ser respondidos. Depois de uma réplica de interconsulta o mesmo
 * formulário tem duas instâncias — o parecer anterior, assinado, e o novo, a responder —; a
 * assinada sai da lista só quando existe outra instância em aberto do mesmo formulário.
 */
export const formulariosParaResponder = (formularios: FormularioAtendimentoList[] = []) => {
  const ativos = formularios.filter((f) => !f.cancelado)
  return ativos.filter(
    (f) =>
      !f.assinado ||
      !ativos.some((o) => o.id !== f.id && o.formulario.id === f.formulario.id && !o.assinado)
  )
}

export const SelecionarFormularioModal: FC<Props> = ({ formularios, onSelect }) => {
  return (
    <div className='d-flex flex-column gap-3'>
      {formularios.map((item) => (
        <Button key={item.id} className='btn-primary' size='btn-sm' onClick={() => onSelect(item)}>
          {item.formulario.nome}
          {/* Data e situação distinguem instâncias do mesmo formulário (ex.: réplica). */}
          {item.dataFormatada && <span className='fw-normal'> · {item.dataFormatada}</span>}
          {item.assinado && <span className='fw-normal'> · assinado</span>}
        </Button>
      ))}
    </div>
  )
}
